import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { EventEmitter } from 'events';

const AddAppointmentsButton = ({ inHeader, content, data }) => {
  /*
   * props:
   *   inHeader: optional, boolean shows if this button is in a header
   *   content: button title
   *   data: pre-selected data for a new appointment
   */

  const openAddAppointmentModal = (e) => {
    e.preventDefault();
    EventEmitter.prototype.emit('appointment-created', { ...data });
    EventEmitter.prototype.emit('open-appointment-modal', 'new');
  };

  const buttonClass = classNames('c-btn c-btn--medium', { 'c-header-primary__button': inHeader });

  return (
    <button
      onClick={openAddAppointmentModal}
      className={buttonClass}
    >
      <span className="c-btn__text">{ content }</span>
    </button>
  );
};

AddAppointmentsButton.propTypes = {
  inHeader: PropTypes.bool,
  content: PropTypes.string.isRequired,
  data: PropTypes.object,
};

export default AddAppointmentsButton;
